import Merchant from './index';

export default { path: '/home/merchant', component: Merchant };
